export const POS_CUSTOM_ITEMS_LOADING = "POS_CUSTOM_ITEMS_LOADING";
export const POS_CUSTOM_ITEMS_LIST = "POS_CUSTOM_ITEMS_LIST";
export const POS_CUSTOM_ITEMS_ERROR = "POS_CUSTOM_ITEMS_ERROR";
